import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as ContactService from '_services/contact-service';
import { useDispatch, useSelector } from 'react-redux';


// post request-demo form
export const requestLiveDemo = createAsyncThunk('requestDemo/requestLiveDemo', async (formState) => {
    return ContactService.requestDemoService(formState);
});

// Initial state for the form
const initialState = {
    name: '',
    email: '',
    phone: '',
    title: '',
    company: '',

    interests: [],  // array of selected "areas of interest" labels

    // status handling
    submissionError: null,  // track any errors
    status: 'idle',         // status
};

const requestDemoSlice = createSlice({
    name: 'requestDemo',
    initialState,
    reducers: {
        // Action to update the value of a form field
        setFormField: (state, action) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        // Action to update selected interests
        setInterests: (state, action) => {
            state.interests = action.payload;
        },
        resetRequestDemo: () => initialState
    },
    extraReducers: {
        [requestLiveDemo.pending]: (state, action) => {
            return {
                ...state,
                status: 'loading',
            }
        },
        [requestLiveDemo.fulfilled]: (state, action) => {
            return {
                ...state,
                status: 'succeeded',
            }
        },
        [requestLiveDemo.rejected]: (state, action) => {
            return {
                ...state,
                status: 'failed',
                submissionError: action.payload || action.error.message || 'Failed to submit demo request. Please try again.',
            }
        }
    }
});

export const { setFormField, setInterests, resetRequestDemo } = requestDemoSlice.actions;

export const requestFormState = state => state.requestDemo
export const selectInterests = state => state.requestDemo.interests;
export const selectStatus = state => state.requestDemo.status;

export default requestDemoSlice.reducer;

